import classNames from 'classnames';
import { LockClosedIcon } from '@heroicons/react/outline';
import IconButton from '../../../components/IconButton';
import { getTimeStamp } from '../../../lib/time';
import { ProgramNoteDataFragment } from '../../../../generated/graphql';
import Pin from '../../../svgs/Pin';
import PinFilled from '../../../svgs/PinFilled';
import { useState } from 'react';

const NotePill: React.FC<{
  isLastNote: boolean;
  programNoteId: string;
  programNote: ProgramNoteDataFragment;
  handleNotePillClick: () => void;
  handlePinNoteClick: (e: any) => void;
}> = ({
  isLastNote,
  programNoteId,
  programNote,
  handleNotePillClick,
  handlePinNoteClick,
}) => {
  const [showPin, setShowPin] = useState(false);

  return (
    <div className={classNames('w-full', isLastNote && 'mb-4')}>
      <div
        onClick={handleNotePillClick}
        onMouseEnter={() => setShowPin(true)}
        onMouseLeave={() => setShowPin(false)}
        className={classNames(
          'flex min-h-[40px] w-full cursor-pointer flex-row items-start justify-between overflow-y-auto rounded-md py-3 pl-4 pr-[16px] hover:rounded-md hover:bg-neutral-25',
          programNoteId === programNote.id &&
            'rounded-md bg-secondary-20 font-medium hover:bg-secondary-25',
          programNote?.isLocked && 'bg-neutral-50',
        )}
      >
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-row items-center gap-1.5 text-caption font-medium leading-tight text-neutral-150 line-clamp-2">
            {programNote.title}
          </div>
          <div className="flex flex-row items-center justify-between gap-2 pt-1 text-small-label text-neutral-125">
            <div className="flex flex-col gap-0.5">
              <div>
                <span className="font-medium">Created:</span>{' '}
                {getTimeStamp(programNote.createdAt, false)}
              </div>
              <div>
                <span className="font-medium">Last updated:</span>{' '}
                {getTimeStamp(programNote.updatedAt, false)}
              </div>
            </div>
            {(showPin ||
              programNote?.isPinnedNote ||
              programNote?.isLocked) && (
              <div className="flex shrink-0 flex-row items-center gap-0.5">
                {(showPin || programNote?.isPinnedNote) && (
                  <IconButton
                    aria-label={
                      programNote?.isPinnedNote ? 'Unpin note' : 'Pin note'
                    }
                    IconComponent={programNote?.isPinnedNote ? PinFilled : Pin}
                    onClick={handlePinNoteClick}
                    className={classNames(
                      'hover:bg-neutral-50',
                      programNote?.isPinnedNote
                        ? 'text-secondary-100  hover:text-secondary-150'
                        : 'text-neutral-125 hover:text-secondary-100',
                    )}
                  />
                )}
                {programNote?.isLocked && (
                  <LockClosedIcon className="h-3.5 w-3.5 flex-shrink-0 text-neutral-125" />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotePill;
